export default __webpack_public_path__ + "static/media/ab-title-en.8ff333d3.webp";